'use strict';
const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const i18n = require('i18next');
const ModalView = require('common/ui/view/modal/index');
const Template = require('balus/ui/template/body/diagram/modal/diagram-item.hbs');

const ImportDiagram = Backbone.Model.extend({
    isSelected: function() {
        return this.get('selected');
    },

    select: function() {
        this.set('selected', true);
    },

    deselect: function() {
        this.set('selected', null);
    }
});

const ImportDiagramCollection = Backbone.Collection.extend({
    model: ImportDiagram,
    initialize: function() {
        this.on('change:selected', this.deselectExcept);
    },
    getSelected: function() {
        return this.find(m => m.isSelected());
    },
    deselectExcept: function(model) {
        if(!model.isSelected()) {
            return;
        }

        this.each(m => {
            if(m != model && m.isSelected()) {
                m.deselect();
            }
        });
    }
});

const ImportDiagramItemView = Mn.View.extend({
    template: Template,
    className: function() {
        if(this.model.isSelected()) {
            return 'list-item is-active';
        }

        return 'list-item';
    },

    triggers: {
        'click': 'select'
    },
    modelEvents: {
        'change:selected': 'changeSelect'
    },

    onSelect: function() {
        this.model.select();
    },

    changeSelect: function() {
        this.$el.toggleClass('is-active', this.model.isSelected());
    }
});

const ImportDiagramListView = Mn.CollectionView.extend({
    childView: ImportDiagramItemView,
    className: 'list list-clickable'
});

module.exports = Mn.View.extend({
    template: false,
    show: function(diagramList) {
        const collection = new ImportDiagramCollection(diagramList);
        const self = this;

        this._modal = new ModalView({
            title: 'Select Diagram',
            bodyView:
                new ImportDiagramListView({
                    collection: collection,
                }),
            onChildviewSave: function() {
                self.trigger('select', collection.getSelected().id);
            }
        });
        collection.on('change:selected', () => {
            this._modal.enableButtons();
        });
        this._modal.show();
    },
    hide: function() {
        this._modal.hide();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/diagram/modal/import-diagram-selector.js